export default __webpack_public_path__ + "static/media/delete-question.8eec9eb2.svg";